import { fetchAPI, METHODS, parseBody } from './common';
import { BRAND_SLUG } from 'src/utils/brand';

export async function getBrandConfig() {
  const query = BRAND_SLUG
    ? `?slug=${encodeURIComponent(BRAND_SLUG)}`
    : `?host=${encodeURIComponent(window.location.hostname)}`;
  const res = await fetchAPI(`/brand/config${query}`, METHODS.get, null, {
    noAuthRefresh: true,
  });
  return parseBody(res, true);
}

// ---- super-admin brand management ----

export async function listBrands() {
  const res = await fetchAPI('/brand', METHODS.get);
  const body = await parseBody(res);
  return {
    brands: body.brands || [],
    slugDomain: body.slugDomain || null,
    senderDomain: body.senderDomain || null,
  };
}

export async function getTeamBrands(teamIds = []) {
  const query = new URLSearchParams({ teamIds: teamIds.join(',') });
  const res = await fetchAPI(`/brand/team-brands?${query}`, METHODS.get);
  const body = await parseBody(res);
  return body.teams || [];
}

export async function fetchBrandPushHealth() {
  const res = await fetchAPI('/brand/push-health', METHODS.get);
  const body = await parseBody(res);
  return body.brands || {};
}

export async function getBrand(id) {
  const res = await fetchAPI(`/brand/${id}`, METHODS.get);
  const body = await parseBody(res);
  return body.brand;
}

export async function searchBrandTeams(search = '') {
  const query = new URLSearchParams();
  if (search.trim()) query.set('search', search.trim());
  const suffix = query.toString() ? `?${query.toString()}` : '';
  const res = await fetchAPI(`/brand/team-options${suffix}`, METHODS.get);
  const body = await parseBody(res);
  return body.teams || [];
}

export async function createBrand(data) {
  const res = await fetchAPI('/brand', METHODS.post, data);
  const body = await parseBody(res);
  return body.brand;
}

export async function updateBrand(id, data) {
  const res = await fetchAPI(`/brand/${id}`, METHODS.put, data);
  const body = await parseBody(res);
  return body.brand;
}

export async function provisionBrandFirebase(id, identifiers) {
  const res = await fetchAPI(
    `/brand/${id}/firebase/provision`,
    METHODS.post,
    identifiers
  );
  const body = await parseBody(res);
  return body.brand;
}

export async function setBrandActive(id, isActive) {
  const res = await fetchAPI(`/brand/${id}/active`, METHODS.post, {
    is_active: isActive,
  });
  const body = await parseBody(res);
  return body.brand;
}

export async function deleteBrand(id) {
  const res = await fetchAPI(`/brand/${id}`, METHODS.delete);
  return parseBody(res);
}

export async function configureBrandDomain(id, domain) {
  const res = await fetchAPI(`/brand/${id}/domain`, METHODS.post, { domain });
  const body = await parseBody(res);
  return body.brand;
}

export async function refreshBrandDomain(id) {
  const res = await fetchAPI(`/brand/${id}/domain/refresh`, METHODS.post);
  const body = await parseBody(res);
  return body.brand;
}

export async function removeBrandDomain(id) {
  const res = await fetchAPI(`/brand/${id}/domain`, METHODS.delete);
  const body = await parseBody(res);
  return body.brand;
}

// ---- per-app minimum builds (Careit has a null brand_id) ----

export async function listMobileApps() {
  const res = await fetchAPI('/mobile-app', METHODS.get);
  const body = await parseBody(res);
  return { apps: body.apps || [], deployments: body.deployments || [] };
}

export async function updateMobileApp(data) {
  const res = await fetchAPI('/mobile-app', METHODS.put, data);
  const body = await parseBody(res);
  return body.app;
}
